export default __webpack_public_path__ + "static/media/StephanieBarger__ponentes.60deb606.png";